import React from 'react';

const Social = () => {
  return (
    <div className="home__social">
      <a href="https://www.instagram.com/zhusupovcv/" className="home__social-icon" target="_blank">
        <i class="uil uil-instagram"></i>
      </a>
      <a href="https://t.me/Birinchi0001" className="home__social-icon" target="_blank">
        <i class="uil uil-telegram-alt"></i>
      </a>
      <a
        href="https://github.com/adiletLover"
        className="home__social-icon"
        target="_blank">
        <i class="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
